module.exports = __webpack_public_path__ + "img/中国邮政储蓄银行_logo.33069d34.png";